<div class="container-fluid">
  <div class="grid" style="padding-top:0.5rem">
    <mat-icon class="pageTitleIcon material-icons-outlined">today</mat-icon>
    <h2 class="pageTitleHeader">Kalender</h2>
  </div>


  <div class="wrapper">
    @if (isLoading()) {
      <div class="overlay">
        <div class='parent'>
          <div class="child">
            <p-progressSpinner  [style]="{width: '100px', height: '100px'}" stroke="grey" strokeWidth="2" animationDuration="1s"></p-progressSpinner>
          </div>
        </div>
      </div>
    }
    <div>
      <p-toolbar>
        <ng-template #start>
          <button #filterButton pButton type="button" icon="pi pi-filter" (click)="filterPanel.toggle($event)"></button>
          <span style="margin-left: 5px;"><label>{{filterlabel}}</label></span>
        </ng-template>
        <ng-template #center>
          <div class="grid">
            <div class="col" >&nbsp;</div>
            <div class="col-6" style="margin-top: 0.5rem ;" >Max. Aufgaben/Zeile</div>
            <div class="col-4"  >
              <p-inputNumber min="1" [size]="'small'"
              [showButtons]="true" [(ngModel)]="eventLineLimit" (ngModelChange)="changeLineLimit()"></p-inputNumber>
            </div>
          </div>
        </ng-template>
        <ng-template #end>
          <div class="grid">
            <div class="col-fixed" style="width: 12rem">
              <p-radiobutton [size]="'small'" inputId="radio1" name="calendarArea" [value]=0 [(ngModel)]="eventRangeTime" (onClick)="changedEventRange($event)"></p-radiobutton>
              <label style="margin-left: 0.4rem;" for="radio1" >Laufzeit</label>
            </div>
            <div class="col-fixed" style="width: 12rem">
              <p-radiobutton [size]="'small'" inputId="radio2" name="calendarArea" value=1  [(ngModel)]="eventRangeTime" (onClick)="changedEventRange($event)"></p-radiobutton>
              <label style="margin-left: 0.4rem;" for="radio2" >Bearbeitungszeit</label>
            </div>

            <div class="col"><p-button icon="pi pi-times" (onClick)="ResetFiltering()"></p-button></div>
          </div>
        </ng-template>
      </p-toolbar>

    </div>
    <div class="calendarContainer">
      <full-calendar [style]="{width: '100%'}" #fc id='fc'  [options]="options"></full-calendar>
    </div>

    <p-popover #filterPanel [dismissable]="false" [style]="{width: '100vH', background: 'lightgray'}"  (onHide)="clearfilter($event)" >

      <ng-template pTemplate="closeicon" let-closeCallback="closeCallback">
        <p-button [rounded]="true" severity="secondary"  style="float: right" (click)="closeCallback($event)" icon="fa-solid fa-xmark" ></p-button>
      </ng-template>
      <ng-template pTemplate="content" >

        <div class="row" style="margin-left: 10px;"><h5>Filter für Kalender</h5></div><hr>
        <div class="row" style="margin-top: 10px;">
          <label for="klammerFilter" style="width: 150px;margin-right: 2px;">&nbsp;&nbsp;Sortimentsklammer:&nbsp;&nbsp;</label>
          <p-select id="klammerFilter" [options]="(isManager$ | async) ? (sortimentsKlammern$ | async)  : (getSupplierKlammern(this.usersCalendarSortimentKlammern$) | async)" optionLabel="name"
            [(ngModel)]="selectedMaster" [showClear]="true"
            [disabled]="(sortimentsKlammern$ | async).length === 0" (ngModelChange)="loadSortiment()" placeholder="Sortimentsklammer wählen">
          </p-select>
        </div>
        @if (isManager$ |async) {
          <div class="row" style="margin-top: 10px;">
            <label for="typfilter" style="width: 150px;;margin-right: 2px;">&nbsp;&nbsp;Typ:&nbsp;&nbsp;</label>
            <p-select id="typFilter"  [options]="sortimentstypen | async" [showClear]="true" [filter]="false"
              [disabled]="(canSelectTypen() | async) == false"
              [(ngModel)]="selectedType" (ngModelChange)="activateTypeFilter(selectedType)" optionLabel="name" placeholder="Typfilter wählen">>
            </p-select>
          </div>
        }
        <div class="row" style="margin-top: 10px;">
          <label for="sortimentFilter" style="width: 150px;;margin-right: 2px;">&nbsp;&nbsp;Sortiment:&nbsp;&nbsp;</label>
          <p-multiSelect [maxSelectedLabels]="1" id="sortimentFilter" [options]="(isManager$ | async) ? (sortiments$ | async) : (getSupplierSortiments(usersCalendarSortimentKlammern$, selectedMaster) | async)"  selectedItemsLabel="{0} Sortimente ausgewählt"
            [disabled]="((sortiments$ | async) === null || (sortiments$ |async).length === 0)" placeholder="Sortiment wählen"
            [(ngModel)]="selectedSortiments" optionLabel="name" (ngModelChange)="activateFilter()">
          </p-multiSelect>
        </div>
      </ng-template>
    </p-popover>
  </div>
</div>
